import type { FC } from 'react';
import styles from './PanelCenter.module.css';
import type { PanelCenterProps } from './PanelCenter.types';
import { getClasses } from '@/_utils/classnames';

export const PanelCenter: FC<PanelCenterProps> = ({
  children,
  className,
  hasLeft,
  hasRight,
}) => {
  const panelCenterClasses: string = getClasses(styles.panelCenter, className, {
    [styles.panelCenterLeft]: hasLeft,
    [styles.panelCenterRight]: hasRight,
  });

  return <section className={panelCenterClasses}>{children}</section>;
};
